module.exports = __webpack_public_path__ + "static/media/instagram-icon.35b38736.svg";